























































































































import ConfirmDialog from '@/components/ConfirmDialog.vue'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({
    components: {
        ConfirmDialog
    }
})
export default class Subscriptions extends Vue {
    @Prop({ required: true }) getDateFormat!: () => {};
    @Prop({ required: true }) refreshTrigger!: boolean
    @Prop({ required: false }) providerId!: number[]
    @Prop({ required: true }) carrierId!: number
    @Prop({ required: true }) formData!: { msisdn: string; provider: null|number }

    localLoading = false

    tables = {
        subscriptions: {
            data: [],
            columns: [
                {
                    text: 'ID',
                    value: 'subscriptionId'
                },
                {
                    text: 'MSISDN',
                    value: 'subscriptionMsisdn'
                },
                {
                    text: 'MDS',
                    value: 'mdsId'
                },
                {
                    text: 'Provider',
                    value: 'providerId.providerName'
                },
                {
                    text: 'Product',
                    value: 'productId.productName'
                },
                {
                    text: 'Shortcode',
                    value: 'shortcodeId.shortcode'
                },
                {
                    text: 'PIN',
                    value: 'pins'
                },
                {
                    text: 'Created At',
                    value: 'subscriptionCreatedAt'
                },
                {
                    text: 'Last Charge',
                    value: 'subscriptionLastChargeAt'
                },
                {
                    text: 'Next Charge',
                    value: 'subscriptionNextChargeAt'
                },
                {
                    text: 'Actions',
                    value: 'options'
                }
            ]
        }
    }

    confirmDialogTrigger = false
    confirmDialogTriggerGenerateCharge= false
    confirmDialogData = null
    confirmDialogDataGenerateCharge = null
    @Watch('refreshTrigger')
    refreshHandler () {
        this.getSubscriptions()
    }

    mounted () {
        this.getSubscriptions()
    }

    getSubscriptions () {
        return new Promise(resolve => {
            this.localLoading = true

            let localProvider = JSON.parse(JSON.stringify(this.providerId))
            if (!Array.isArray(localProvider)) localProvider = localProvider ? [localProvider] : []

            this.$store.dispatch('getSubscriptions', {
                carrierId: this.carrierId,
                msisdn: this.formData.msisdn,
                providerId: localProvider
            })
                .then(resp => {
                    if (resp?.status === 200) {
                        const subscriptions = this.$store.state.MonitorStore.subscriptions

                        subscriptions.forEach((s: {options: object}) => {
                            s.options = {}
                        })

                        this.tables.subscriptions.data = subscriptions
                        this.localLoading = false
                        this.$emit('localLoadingEnd')
                        resolve()
                    }
                })
        })
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getBillSubscription (item: any) {
        return new Promise(resolve => {
            this.localLoading = true
            this.$store.dispatch('getBillSubscriptions', item.subscriptionId)
                .then(resp => {
                    if (resp?.status === 200) {
                        const blob = new Blob([resp.data], { type: 'application/pdf' })
                        const url = window.URL.createObjectURL(blob)
                        const link = document.createElement('a')

                        link.href = url

                        const contentDisposition = resp.headers['content-disposition']
                        let fileName = `subscription-statement-${item.subscriptionMsisdn}-${item.subscriptionId}.pdf`

                        if (contentDisposition) {
                            const fileNameMatch = contentDisposition.match(/filename="?([^";]+)"?/)
                            if (fileNameMatch && fileNameMatch.length > 1) {
                                fileName = fileNameMatch[1]
                            }
                        }

                        link.setAttribute('download', fileName)
                        document.body.appendChild(link)
                        link.click()

                        setTimeout(() => {
                            document.body.removeChild(link)
                            window.URL.revokeObjectURL(url)
                            this.localLoading = false
                            resolve('')
                        }, 100)
                    } else {
                        this.localLoading = false
                    }
                })
                .catch(error => {
                    this.localLoading = false
                    console.error('Error descargando PDF:', error)
                })
        })
    }

    confirmedDialog (item: {subscriptionId: number}) {
        return new Promise(resolve => {
            this.localLoading = true
            this.$store.dispatch('deactivateSubscriptions', item.subscriptionId)
                .then(resp => {
                    if (resp.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        this.getSubscriptions()
                        resolve()
                    } else {
                        this.localLoading = false
                    }
                })
        })
    }

    confirmedDialogGenerateCharge (item: {subscriptionId: number}) {
        return new Promise(resolve => {
            this.localLoading = true
            this.$store.dispatch('generateChargeSubscriptions', item.subscriptionId)
                .then(resp => {
                    if (resp.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        this.getSubscriptions()
                        resolve()
                    }
                })
        })
    }
}

